module.exports = __webpack_public_path__ + "img/vpn.1894ee5b.png";